<template>
  <metainfo></metainfo>

  <component :is="componentToRender" v-if="componentToRender"></component>
</template>

<script>
import {defineComponent, computed} from "vue"
import {useMeta} from "vue-meta"
import {useRoute} from "vue-router"
import Helper from "@/services/Helper"
import TelegramCreateUpdate from "@/modules/post/pages/telegram/edit/Index"
import SiteCreateUpdate from "@/modules/post/pages/site/edit/Index"

export default defineComponent({
  name: "PostCreate",
  components: {
    TelegramCreateUpdate,
    SiteCreateUpdate,
  },
  setup() {
    useMeta({title: "Создание поста"})

    const route = useRoute()

    const channelId = computed(() => {
      return parseInt(route.params.channel_id)
    })

    const componentToRender = computed(() => {
      const id = channelId.value

      if (isTelegramChannel(id)) {
        return "TelegramCreateUpdate"
      } else if (isSiteChannel(id)) {
        return "SiteCreateUpdate"
      } else {
        throw new Error("Неверный канал")
      }
    })

    function isTelegramChannel(channelId) {
      return Helper.inArray([channelId], [2, 3, 4, 5, 7, 8, 9, 10, 11, 12])
    }

    function isSiteChannel(channelId) {
      return Helper.inArray([channelId], [1])
    }

    return {
      componentToRender,
    }
  },
})
</script>
